import { CruiseList } from '../cruise-list/cruise-list';
import { CruisesHelp } from '../cruises-help/cruises-help';
import classes from './cruises.module.css';

const styles = {
  help: {
    flex: '1 1 100%',
  },
  list: {
    flex: 1,
  },
};

export function Cruises() {
  return (
    <div className={classes.cruises}>
      <CruisesHelp style={styles.help} />
      <CruiseList style={styles.list} />
    </div>
  );
}
